import { incYenOf } from '../lib/pricing';
export const commercialLawHero = {
  title: '特定商取引法に基づく表記',
  titleEn: 'COMMERCIAL TRANSACTIONS ACT',
  lead: '一般社団法人全日本執事協会が運営する日本執事アカデミーの提供する教育サービスについて、特定商取引に関する法律第11条に基づき、以下の事項を表示いたします。',
};

export interface CommercialLawItem {
  id: string;
  label: string;
  content: string[];
}

export const commercialLawItems: CommercialLawItem[] = [
  {
    id: 'item-seller',
    label: '販売事業者',
    content: [
      '一般社団法人 全日本執事協会',
      '当協会は、日本執事アカデミーを運営し、執事教育サービスを提供する一般社団法人です。',
    ],
  },
  {
    id: 'item-representative',
    label: '代表者',
    content: [
      '準備中',
      '代表者名は確定次第、速やかに本ページへ掲載いたします。現時点では「準備中」とさせていただきます。',
    ],
  },
  {
    id: 'item-address',
    label: '所在地',
    content: [
      '〒135-0064 東京都江東区青海2丁目7-4',
      '東京臨海新交通臨海線（ゆりかもめ）「東京国際クルーズターミナル駅」より徒歩約5分です。詳しいアクセス方法はアクセスページをご覧ください。',
    ],
  },
  {
    id: 'item-phone',
    label: '電話番号',
    content: [
      '03-6824-4086',
      '受付時間：平日 10:00〜17:00（土日祝日を除く）',
      'お電話でのお問い合わせは、上記の受付時間内にお願いいたします。時間外のお問い合わせは、お問い合わせフォームまたはメールにて承ります。',
    ],
  },
  {
    id: 'item-email',
    label: 'メールアドレス',
    content: [
      'info@butler-academy.jp',
      'お問い合わせはメールでも承っております。お気軽にご連絡ください。なお、お返事には2〜3営業日程度お時間をいただく場合がございます。',
    ],
  },
  {
    id: 'item-price',
    label: '販売価格',
    content: [
      '各コースの受講料は以下のとおりです（いずれも消費税込みの総額表示）。',
      `・エッセンシャルコース：${incYenOf('ac-essential')}円（税込）`,
      `・アドバンスコース：${incYenOf('ac-advanced')}円（税込）`,
      `・マスターコース：${incYenOf('ac-master')}円（税込）`,
      `・体験講座：${incYenOf('ac-trial')}円（税込）`,
      '法人研修の価格は、各業種別プランページに記載しております。詳しくは料金概要ページおよび各コースページをご参照ください。',
    ],
  },
  {
    id: 'item-extra-fees',
    label: '商品代金以外の必要料金',
    content: [
      '銀行振込手数料は、受講生の皆様のご負担となります。',
      '出張を伴う実習または法人研修の実施にあたり、交通費および宿泊費が発生する場合は実費をご負担いただきます。',
      '教材費は受講料に含まれておりますので、別途ご負担いただく必要はございません。',
    ],
  },
  {
    id: 'item-payment-method',
    label: '支払方法',
    content: [
      '銀行振込（一括払い）のみのお取扱いとなります。',
      '分割払いおよびクレジットカードでのお支払いはご利用いただけません。あらかじめご了承ください。',
      '法人研修の場合は、請求書払い（銀行振込）にて承ります。請求書は研修実施の約1ヶ月前にお送りいたします。',
    ],
  },
  {
    id: 'item-payment-timing',
    label: '支払時期',
    content: [
      '受講料は、各コース開講日の14日前までにお振込みください。',
      '法人研修のお支払時期は、別途ご案内いたします。原則として、請求書到着後30日以内のお振込みをお願いしております。',
    ],
  },
  {
    id: 'item-service-timing',
    label: '役務の提供時期',
    content: [
      '各コースの開講日に役務の提供を開始いたします。開講日は年間スケジュールページにてご確認いただけます。',
      '法人研修は、お客様と合意した実施日に研修を提供いたします。',
      '体験講座は、各回の開催日が確定次第、当サイト上でご案内いたします。',
    ],
  },
  {
    id: 'item-cancellation',
    label: 'キャンセル・返金について',
    content: [
      '本サービスは役務（教育サービス）の提供であるため、物品の返品には該当いたしません。',
      'キャンセルおよび返金の取扱いについては、募集要項に定めるキャンセル規定に従います。詳しくは応募資格・申込の流れのページをご確認ください。',
      '開講日の14日前までにご連絡いただいた場合、所定の手数料を差し引いた金額をご返金いたします。開講日までの日数によりキャンセル料が異なりますので、募集要項を必ずご確認ください。',
    ],
  },
  {
    id: 'item-special-conditions',
    label: '特別の販売条件',
    content: [
      '各コースは定員6名、最少催行人数3名にて開校いたします。',
      '最少催行人数に満たない場合は、開校を見送らせていただく場合がございます。その際は、お振込みいただいた受講料を全額ご返金いたします。',
      '定員を超過した場合は先着順とし、次回以降の開講をご案内いたします。',
    ],
  },
];

export const commercialLawNote = '本表記は、特定商取引に関する法律第11条に基づき、役務（教育サービス）の提供に関する事項を表示したものです。価格その他の取引条件は予告なく変更する場合がございます。最新の情報は当サイトにてご確認ください。';

export const commercialLawRelatedLinks = [
  {
    label: '利用規約',
    href: '/terms',
    description: '当サイトのご利用にあたっての条件を定めています。',
  },
  {
    label: 'プライバシーポリシー',
    href: '/privacy',
    description: '個人情報の取扱い方針を明示しています。',
  },
  {
    label: '応募資格・申込の流れ',
    href: '/application',
    description: 'キャンセル規定を含む募集要項をご確認いただけます。',
  },
];